import dayjs from 'dayjs';

// let offset = date.getTimezoneOffset() * 60000; //ms단위라 60000곱해줌
// let dateOffset = new Date(date.getTime() - offset);
// console.log(dateOffset.toISOString());

type Props = {
  showTime?: boolean;
};

export function dateAgo(createAt: any, showTime: boolean = true) {
  if (createAt) {
    const value = createAt.seconds
      ? createAt.seconds * 1000
      : createAt._seconds * 1000; //1605600280000 ...

    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(seconds / 3600);
      const days = Math.floor(seconds / 86400);

      // 30초 미만 → 방금
      if (seconds < 30) return '방금';

      // 30초 ~ 59초 → 1분 전
      if (minutes < 1) return '1분 전';

      // 1분 ~ 44분 → N분 전
      if (minutes < 45) return `${minutes}분 전`;

      // 45분 ~ 89분 → 약 1시간 전 (부드러운 전환 구간)
      if (minutes < 90) return '약 1시간 전';

      // 90분 ~ 23시간 → N시간 전
      if (hours < 24) return `${hours}시간 전`;

      // 1일 ~ 3일 → N일 전
      if (days <= 3) return `${days}일 전`;

      // 3일 초과 → 날짜 표시
      const thisYear = new Date().getFullYear();
      const compareYear = new Date(value).getFullYear();

      if (thisYear === compareYear) {
        return showTime
          ? dayjs(value).format('MM.DD HH:mm')
          : dayjs(value).format('MM.DD');
      }
      return showTime
        ? dayjs(value).format('YYYY.MM.DD HH:mm')
        : dayjs(value).format('YYYY.MM.DD');
    }

    return value;
  }
}

/** Firestore Timestamp → ms 변환 (TimeAgo 컴포넌트용) */
export function toMillis(createAt: any): number | null {
  if (!createAt) return null;
  const value = createAt.seconds
    ? createAt.seconds * 1000
    : createAt._seconds
      ? createAt._seconds * 1000
      : null;
  return value || null;
}

export function timestampToDateString(
  initialValue: any,
  format?: string,
): string {
  const safeFormat = format || 'YYYY-MM-DD';

  if (!initialValue) return ''; // null, undefined 등 처리

  // 1. Firestore Timestamp 객체: { seconds, nanoseconds }
  if (typeof initialValue === 'object') {
    const seconds =
      initialValue.seconds ??
      initialValue._seconds ?? // Algolia에서 온 경우
      null;

    if (typeof seconds === 'number') {
      return dayjs(seconds * 1000).format(safeFormat);
    }
  }

  // 2. 문자열 또는 Date 객체
  const parsed = dayjs(initialValue);
  return parsed.isValid() ? parsed.format(safeFormat) : '';
}

export function timestampToDate(initialValue: any): Date | null {
  if (!initialValue) return null;
  if (typeof initialValue === 'object') {
    const setValue = initialValue.seconds * 1000;
    return new Date(setValue);
  } else {
    return new Date(initialValue * 1000);
  }
}

export function dateToTimestamp(value) {
  return Math.round(new Date(value).getTime() / 1000);
}

export function nowDateToTimestamp() {
  return Math.round(new Date().getTime());
}
